import { useEffect, useState } from "react";
import { FacebookPixel } from "react-use-facebook-pixel";

const useMetaPixel = () => {
  const [facebookPixel, setFacebookPixel] =
    (useState < FacebookPixel) | (null > null);

  useEffect(() => {
    const initializeFacebookPixel = async () => {
      const pixel = new FacebookPixel({
        pixelID: "1168802924728030",
      });

      pixel.init({});

      setFacebookPixel(pixel);
    };

    initializeFacebookPixel();
  }, []);

  return facebookPixel;
};

export default useMetaPixel;
